module.exports = __webpack_public_path__ + "img/gift4-01-c10-t2.4da01100.png";